<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#939498;}
</style>
<path class="st0" d="M14,5c0.6,0,1,0.4,1,1v1H8C7.5,7,7.1,7.4,7,7.9L7,8v7H6c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1H14z M10,9h8
	c0.6,0,1,0.4,1,1v8c0,0.6-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1v-8C9,9.4,9.4,9,10,9z M12.4,12h3.2c0.2,0,0.4,0.2,0.4,0.4v3.2
	c0,0.2-0.2,0.4-0.4,0.4h-3.2c-0.2,0-0.4-0.2-0.4-0.4v-3.2C12,12.2,12.2,12,12.4,12z"/>
</svg>
